import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requiredRole?: 'admin' | 'employee';
}

export const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
    const { user, session } = useAuthStore();
    const location = useLocation();

    if (!session || !user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If a specific role is required, check if the user has that role
    if (requiredRole && user.role !== requiredRole) {
        return <Navigate to={user.role === 'admin' ? '/admin' : '/dashboard'} replace />;
    }

    // Check if user is trying to access admin routes without admin role
    if (location.pathname.startsWith('/admin') && user.role !== 'admin') {
        return <Navigate to="/dashboard" replace />;
    }

    // Check if admin is trying to access employee routes
    if (!location.pathname.startsWith('/admin') && user.role === 'admin') {
        return <Navigate to="/admin" replace />;
    }

    return <>{children}</>;
}; 